import { excludeForwardProps as o } from "../../utils/excludeForwardProps.js";
import { styled as r, Typography as t } from "@mui/joy";
const l = r(t, { shouldForwardProp: o(["lightColor", "darkColor"]) })(({ theme: o2, lightColor: r2, darkColor: t2 }) => ({ color: o2.palette.isDarkMode ? t2 ?? o2.palette.neutral[600] : r2 ?? o2.palette.neutral[700] }));
export {
  l as BaseTypography
};
//# sourceMappingURL=BaseTypography.js.map
